import { gettext } from '@eventbrite/i18n';
import { CheckoutState } from '../../state';
import { getAttendeeFirstName } from '../forms';
import { isOrganizerQuestionsPage } from '../routing';
import { getNamespaceValue } from '../utils/selector';
import { getQuestionsForAttendees } from './attendees';

export const getAttendeesSelectorOptions = (state: CheckoutState) => {
    const attendees = getNamespaceValue(state.order, 'attendees');
    const attendeeSurvey = getQuestionsForAttendees(state);
    const isOrgQuestionsPage = isOrganizerQuestionsPage(state);

    return attendeeSurvey.map(({ id, ticketClassName }) => {
        const ticketIndex = attendees.findIndex(
            ({ id: attendeeId }) => id === attendeeId,
        );

        return {
            value: id,
            display: isOrgQuestionsPage
                ? getAttendeeFirstName(state, id)
                : gettext('Ticket %(ticketNumber)s · %(ticketClassName)s', {
                      ticketNumber: ticketIndex + 1,
                      ticketClassName,
                  }),
        };
    });
};
